export type VerticalSpaceProps = {
  xlarge?: boolean
  large?: boolean
  medium?: boolean
  smallMedium?: boolean
  small?: boolean
  tiny?: boolean
}

const height = ({ xlarge, large, medium, smallMedium, small, tiny }: VerticalSpaceProps) => {
  if (xlarge) return 36
  if (large) return 24
  if (medium) return 16
  if (smallMedium) return 12
  if (small) return 8
  if (tiny) return 4
  return 8
}

export const VerticalSpace = (props: VerticalSpaceProps) => (
  <div style={{ height: height(props) }} />
)
